<template>
  <div class="pt-0 pl-0 pr-0 accordion desktop-menu-accordion" role="tablist" data-test-id="desktop-menu" style="overflow-y: auto">
    <MenuItems type="desktop-menu" :openedItem.sync="defaultOpenedItem"></MenuItems>
  </div>
</template>

<script>

import MenuItems from "@/components/dashboard/menu/MenuItems";

export default {
  name: "DesktopMenu",
  components: {MenuItems},
  data: function () {
    return {
      defaultOpenedItem: null  //'plm', 'dict', etc.
    }
  }
}
</script>

<style scoped>
  .desktop-menu-accordion {
    width: 100%;
    /*white-space: nowrap;*/
    background-color: #6c828c;
  }

</style>